/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isEmailVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    role?: UserEntityRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserEntity
     */
    lastActive?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    customerType?: UserEntityCustomerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserEntity
     */
    adminStores?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isEmailNotifActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isSmsNotifActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    alertOnUserRegistration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    alertOnOrderCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    alertOnOrderDelivery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    alertOnNewReview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isTaxExempted?: boolean;
    /**
     * ISO 3166-1 alpha-2 country code ... examples -> https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
     * @type {string}
     * @memberof UserEntity
     */
    country?: string;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    availableCreditBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    creditLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    creditUsed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    isAllowedtToUseCredit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    ordersCount: number;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    totalSpent: number;
}

/**
    * @export
    * @enum {string}
    */
export enum UserEntityRoleEnum {
    SuperAdmin = 'SuperAdmin',
    Admin = 'Admin',
    User = 'User'
}
/**
    * @export
    * @enum {string}
    */
export enum UserEntityCustomerTypeEnum {
    B2B = 'B2B',
    Regular = 'Regular'
}

